import React from "react";
import { motion } from "framer-motion";
import { FlameIcon } from "lucide-react";
const SPOTS_LEFT = 7;
const FILLED = 94;
export function ScarcityBar() {
  return <div className="w-full" data-id="element-72" data-mp="2yy5nyvthfm87">
      <div className="flex items-end justify-between gap-3" data-id="element-73" data-mp="2l5pp877m6ad3">
        <p className="flex items-center gap-1.5 text-left text-[15px] font-bold leading-snug text-ink" data-id="element-74" data-mp="2l33ha6gt9suc">
          <FlameIcon className="h-5 w-5 shrink-0 text-alert" aria-hidden="true" data-id="element-75" data-mp="2q1oavn1k5e9t" />
          Only <span className="text-alert" data-id="element-76" data-mp="2b8ut1uytcm1z">{SPOTS_LEFT} spots left</span> at the promotional price
        </p>
        <span className="shrink-0 text-sm font-extrabold text-alert" data-id="element-77" data-mp="2g3gtx479qw7t">{FILLED}%</span>
      </div>
      <div className="mt-2 h-4 w-full overflow-hidden rounded-full bg-mist ring-1 ring-navy-900/10" role="progressbar" aria-valuenow={FILLED} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-78" data-mp="228eqqott3kyp">
        <motion.div className="h-full rounded-full bg-alert" initial={{
        width: "60%"
      }} whileInView={{
        width: `${FILLED}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-79" data-mp="5d9z17mh6w76" />
      </div>
      <p className="mt-1.5 text-left text-xs font-medium text-ink-muted" data-id="element-80" data-mp="3dbmy4prwzrfl">
        When the spots run out, the price returns to the full suggested value.
      </p>
    </div>;
}